export default ({ request }) => ({
  processDictionaryListApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/list',
      method: 'post',
      data,
    })
  },
  processDictionaryDetailApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/detail',
      method: 'post',
      data,
    })
  },
  processDictionarySaveApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/save',
      method: 'post',
      data,
    })
  },
  processDictionaryDelApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/del',
      method: 'post',
      data,
    })
  },
  processDictionaryCopyApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/copy',
      method: 'post',
      data,
    })
  },
  processDictionaryReviewApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/review',
      method: 'post',
      data,
    })
  },
  processDictionaryDeactivateApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/deactivate',
      method: 'post',
      data,
    })
  },
  processDictionaryEnableApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/enable',
      method: 'post',
      data,
    })
  },
  processDictionaryFabricListApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/fabric/list',
      method: 'post',
      data,
    })
  },
  processDictionaryFabricSelectApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/fabric/select',
      method: 'post',
      data,
    })
  },
  processDictionaryFabricDetailApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/fabric/detail',
      method: 'post',
      data,
    })
  },
  processDictionaryFabricSaveApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/fabric/save',
      method: 'post',
      data,
    })
  },
  processDictionaryFabricDelApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/fabric/del',
      method: 'post',
      data,
    })
  },
  processDictionaryTechListApi(data = {}) {
    return request({
      url: '/factory/pd/process/dictionary/tech/list',
      method: 'post',
      data,
    })
  },
})
